import type { Observable } from 'rxjs';
import { useObservableState } from 'observable-hooks';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartStep } from '@awesome.me/kit-eb69e755a9/icons/kit/custom';

import {
    faChartColumn,
    faChartLine,
    faChartScatter,
} from '@awesome.me/kit-eb69e755a9/icons/sharp/solid';
import { GraphType } from '@/graphql/types';
import { GRAPH_TYPE_ORDER } from './GraphType.constants';
import { GraphToolbarButton } from './GraphToolbarButton';

export interface GraphTypeController {
    graphType$: Observable<GraphType>;
    setGraphType: (graphType: GraphType) => void;
}

const GRAPH_TYPE_LABEL_MAP: Record<GraphType, () => string> = {
    [GraphType.Line]: () => gettext('GRAPH_TYPE_OPTION_LINE'),
    [GraphType.Bar]: () => gettext('GRAPH_TYPE_OPTION_BAR'),
    [GraphType.Dot]: () => gettext('GRAPH_TYPE_OPTION_DOT'),
    [GraphType.Step]: () => gettext('GRAPH_TYPE_OPTION_STEP'),
};

const GRAPH_TYPE_ICON_MAP: Record<GraphType, IconDefinition> = {
    [GraphType.Line]: faChartLine,
    [GraphType.Bar]: faChartColumn,
    [GraphType.Dot]: faChartScatter,
    [GraphType.Step]: faChartStep,
};

export function GraphTypeSelector({ graph }: { graph: GraphTypeController }): JSX.Element {
    const currentGraphType = useObservableState(graph.graphType$);

    return (
        <>
            {GRAPH_TYPE_ORDER.map((graphType) => (
                <GraphToolbarButton
                    key={graphType}
                    ariaLabel={`${gettext('GRAPH_TYPE')}: ${GRAPH_TYPE_LABEL_MAP[graphType]()}`}
                    active={currentGraphType === graphType}
                    onClick={() => {
                        graph.setGraphType(graphType);
                    }}
                >
                    <FontAwesomeIcon icon={GRAPH_TYPE_ICON_MAP[graphType]} size="xl" />
                </GraphToolbarButton>
            ))}
        </>
    );
}
